<template>
  <div class="container">
    <div>
      <div class="discount-mention" v-if="isNew && 0">
        <label class="discount-mention-label" @click="isUseFirstFree = !isUseFirstFree">
          <p>你有一次<span>免費體驗</span>的優惠權益，點擊使用</p>
        </label>
        <van-checkbox v-model="isUseFirstFree" shape="square"></van-checkbox>
      </div>
    </div>
    <div class="content">
      <div class="pay-box">
        <div class="pay-title">{{ goods.name }}</div>
        <div class="pay-label">请选择您需要评估的疾病种</div>

        <div class="pay-package">

          <el-checkbox-group v-model="isUseFirstFree" v-if="isNew">
            <el-checkbox label="1" class="pay-el-checkbox" style="background-color: #6681FA10;">
              <p>你有一次<span style="color: red;font-weight: bold;">免費體驗</span>的優惠權益，點擊使用</p>
            </el-checkbox>
          </el-checkbox-group>
          <el-checkbox-group v-model="selectedPackage" @change="handleCheckedCitiesChange" :disabled="isUseFirstFree">
            <el-checkbox v-for="p in packages" :label="p.id" :key="p.id" :disabled="p.disabled"
              class="pay-el-checkbox">{{ p.name
              }}</el-checkbox>

          </el-checkbox-group>
        </div>
        <div class="pay-tip primary-color">每種疾病{{ goods.price }}點券（原價{{ goods.cost_price }}點券，優惠價{{ goods.price }}點券）
        </div>
        <div class="pay-tip">（多選則疊加，例如選擇腦中風+心梗則結算{{ goods.price * 2 }}點券）</div>
      </div>
      <div class="tip tip-mention">
        <div class="tip-mention-label">請注意你需要提供生化指標</div>
        <div class="tip-mention-action" @click="isPayTipsShow = true">查看</div>
      </div>
    </div>
    <div class="footer">

      <div class="price">
        <p>合計：{{ totalLastPrice }}點券</p>
      </div>
      <div class="score" v-if="isUseFirstFree">優惠權益：{{ totalLastPrice }}點券</div>
      <div class="score" v-else>優惠權益：{{ totalLastPrice - totalPrice }}點券</div>
      <div class="last-price">你還需要支付：<span>{{ isUseFirstFree ? 0 : totalPrice }}點券</span></div>
      <div v-if="isUseFirstFree" class="submit" @click="handleConfirmPay">兑換</div>
      <div v-else class="submit" @click="handleConfirmPay">訂購</div>
    </div>
    <van-popup v-model="isPayTipsShow" position="center">
      <div class="pay-tips">
        <div class="pay-tips-title">溫馨提示</div>
        <div class="pay-tips-content">
          <p>你需要提供生化指標，包括：空腹血糖，糖化血色素，總膽固醇，高密度膽固醇，低密度膽固醇，三酸甘油酯，尿酸；</p>
          <p>以上7項生化指標中的<span>至少一項</span>，提供的指標愈多，AI分析結果愈精准；</p>
        </div>
        <div class="pay-tips-footer">
          <div @click="isPayTipsShow = false" class="pay-tips-footer-primary">我知道了</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="isPayTipsWhitOutFirstFreeShow" position="center">

      <div class="dialog-confirm-content">

        <div class="dialog-confirm-header">溫馨提示</div>
        <div class="dialog-confirm-body">
          <p>你有一次<span>免費體驗</span>的優惠權益，<br>確定不使用嗎？</p>
        </div>
        <div class="dialog-confirm-footer">
          <div class="dialog-confirm-footer-text" @click="payWithoutFirstFree">暫不使用</div>
          <div class="dialog-confirm-footer-primary" @click="payWithFirstFree">去使用</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="isPayLoading" position="center" :close-on-click-overlay="false" :close-on-popstate="false">
      <img src="https://medin.oss-cn-shanghai.aliyuncs.com/file/images/cmhk/mylinkxiaolimao.gif" alt="loading">
    </van-popup>
    <pay-confirm ref="payConfirmRef" @submit="pay" />
  </div>
</template>

<script>
import { payMyLink, addPayMyLink, getPackagePrice, getUserHasUse } from '@/js/axios'
import { Base64 } from 'js-base64';
import { Toast } from 'vant' //vant-UI的提示組件
import payConfirm from './payConfirm.vue';

export default {
  name: 'myLinkPay',
  components: {
    payConfirm
  },
  data () {
    return {
      totalScore: 0,
      qid: "",
      isPayTipsShow: false,
      goods: {
        price: 0,
        name: "套餐",
        cost_price: 0,
      },
      packages: [
        {
          id: "A05",
          name: '痛風風險',
          disabled: false
        },
        {
          id: "A03",
          name: '心肌梗塞風險',
          disabled: false
        },
        {
          id: 'A17',
          name: '腦中風風險',
          disabled: false
        },
        {
          id: "A07",
          name: '癌症風險',
          disabled: false
        },
      ],
      selectedPackage: [],
      type: "pay",
      disBuy: [],
      isNew: false,
      isUseFirstFree: false,
      isPayTipsWhitOutFirstFreeShow: false,
      isSkipUseFirstFree: false,
      isPayLoading: false,
    };
  },
  created () {
    const { type } = this.$route.query
    if (type === "add") {
      this.type = "add"

    } else {
      this.type = "pay"

      if (this.$store.state.firstFree) {
        this.isUseFirstFree = true
        this.isNew = true
      }
    }
    const { dis, buy, id } = this.$route.query
    if (id) {
      this.qid = id
    }
    if (dis) {
      const arr = dis.split(',')
      let selectedPackage = arr
      this.packages.forEach(p => {
        if (selectedPackage.includes(p.id)) {
          p.disabled = true
        }
      })
      this.disBuy = arr
      if (buy) {
        selectedPackage = [...selectedPackage, buy]
      }
      this.selectedPackage = selectedPackage
    }
    this.getPackages()

  },
  watch: {
    isUseFirstFree (val) {
      if (val) {
        const selectedPackages = this.packages.map(p => p.id)
        this.selectedPackage = selectedPackages

      }
    }
  },
  mounted () {

  },
  computed: {
    totalPrice () {
      return this.selectedPackage.reduce((acc, cur) => {
        const p = this.packages.filter(i => !i.disabled).find(p => p.id === cur)
        return acc + (p ? this.goods.price : 0)
      }, 0);
    },
    totalLastPrice () {
      return this.selectedPackage.reduce((acc, cur) => {
        const lastP = this.packages.filter(i => !i.disabled).find(p => p.id === cur)
        return acc + (lastP ? this.goods.cost_price : 0);
      }, 0);
    }
  },

  methods: {
    async getPackages () {
      const res = await getPackagePrice()
      console.log(res);
      if (res.code === 200) {
        const data = JSON.parse(Base64.decode(res.data))
        console.log("data", data);
        this.goods = data
      }

    },
    toggle (index) {
      this.$refs.checkboxes[index].toggle();
    },
    handleCheckedCitiesChange () {

    },
    payWithFirstFree () {
      this.isUseFirstFree = true
      this.isPayTipsWhitOutFirstFreeShow = false
    },
    payWithoutFirstFree () {
      this.isUseFirstFree = false
      this.isPayTipsWhitOutFirstFreeShow = false
      this.isSkipUseFirstFree = true
    },
    handleConfirmPay () {
      if (this.selectedPackage.length === 0) {
        Toast.fail('請至少選擇一項')
        return
      }
      if (this.type === "add") {
        if (!this.qid) {
          Toast.fail('請選擇选择合法的订单')
          return
        }
        const arr = this.selectedPackage.filter(i => !this.disBuy.includes(i))
        if (arr.length === 0) {
          Toast.fail('請至少選擇一項')
          return
        }
      }
      this.$refs.payConfirmRef?.open({
        price: this.totalPrice,
      })
    },
    pay () {
      if (this.selectedPackage.length === 0) {
        Toast.fail('請至少選擇一項')
        return
      }
      const data = {
        dis: this.selectedPackage,

      }

      if (this.type === "add") {
        if (!this.qid) {
          Toast.fail('請選擇选择合法的订单')
          return
        }
        const arr = this.selectedPackage.filter(i => !this.disBuy.includes(i))
        if (arr.length === 0) {
          Toast.fail('請至少選擇一項')
          return
        }
        const addData = {
          id: this.qid,
          dis: arr,
        }
        this.isPayLoading = true
        addPayMyLink(addData).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.isPayLoading = false
            Toast.success(res.msg)

            this.$router.replace(`/history`)

          } else {
            this.isPayLoading = false
            Toast.fail(res.msg)
          }
        })
      } else {
        if (this.isNew && !this.isUseFirstFree && !this.isSkipUseFirstFree) {
          this.isPayTipsWhitOutFirstFreeShow = true
          return
        }
        data.firstFree = this.isUseFirstFree ? 1 : 0
        this.isPayLoading = true
        payMyLink(data).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.isPayLoading = false
            Toast.success('支付成功')
            this.checkUserUse()
            this.$router.replace(`/history`)
          } else {
            this.isPayLoading = false
            Toast.fail(res.msg)
          }
        })
      }
    },
    async checkUserUse () {
      const res = await getUserHasUse()
      if (res.code == 200) {
        const data = JSON.parse(Base64.decode(res.data))
        const { firstUse, firstFree } = data
        console.log(firstUse, firstFree)
        if (firstUse) {
          this.$store.commit('changeFirstUse', firstUse)
        } else {
          this.$store.commit('changeFirstUse', 0)
        }
        if (firstFree) {
          this.$store.commit('changeFirstFree', firstFree)
        } else {
          this.$store.commit('changeFirstFree', 0)
        }
      }
    }
  },
};
</script>

<style scoped>
.pay-package>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #6681FA;

}

.pay-package>>>.el-checkbox__label {
  padding: 0;
  font-weight: 400;
  font-size: 0.28rem;
  line-height: 0.4rem;
  text-align: left;
  font-style: normal;
}

.red {
  color: #d40606 !important;
}
</style>

<style lang="scss" scoped>
.primary-color {
  color: #6681FA;

}

.pay-package {
  ::v-deep>>>.el-checkbox__label {
    p {
      font-size: .24rem;
      font-weight: bold;

      span {
        font-weight: bold;
        color: #DB0007;
      }
    }

    &::before {
      content: '';
      display: block;
      width: .64rem;
      height: .64rem;
      background-image: url(../../assets/images/myLink/firstFree.png);
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center;
      margin-right: .24rem;
    }
  }
}

.container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;


  .discount-mention {
    position: relative;
    padding: .24rem 0.48rem;
    background-color: #EAEEFF;
    width: 100%;
    box-shadow: inset 0 0 0.12rem rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;



    &-label {
      display: flex;
      align-items: center;

      p {
        font-size: .24rem;
        font-weight: bold;

        span {
          font-weight: bold;
          color: #DB0007;
        }
      }

      &::before {
        content: '';
        display: block;
        width: .64rem;
        height: .64rem;
        background-image: url(../../assets/images/myLink/firstFree.png);
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: .24rem;
      }
    }

  }

  .van-nav-bar-title {
    flex: 0 0 auto;
  }

  .content {
    flex: 1;
    padding: .24rem;

    >div {
      background-color: #fff;

      &:not(:last-child) {
        margin-bottom: .24rem;
      }
    }

    .tip {
      padding: .24rem;
      font-weight: 400;
      font-size: 0.24rem;
      color: #666666;
      line-height: 0.3rem;
      text-align: left;
      font-style: normal;
      background-color: #EAEEFF;
      border-radius: 0.2rem;
    }

    .tip-mention {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-label {
        color: #DB0007;
        display: flex;
        align-items: center;

        &::before {
          content: "!";
          display: block;
          width: .24rem;
          height: .24rem;
          color: #ffffff;
          font-size: 0.16rem;
          font-weight: bold;
          border-radius: 50%;
          margin-right: .12rem;
          background-color: #DB0007;
          text-align: center;
          line-height: .24rem;
        }
      }

      &-action {
        padding: .1rem .2rem;
        color: #ffffff;
        background-color: #6681FA;
        border-radius: .24rem;
      }
    }

    .pay-box {
      padding: .24rem;

      >div {
        position: relative;
        width: 100%;
      }

      .pay-title {
        height: 1.04rem;
        display: flex;
        align-items: center;
        font-size: .28rem;
        border-bottom: 1px solid #00000016;
        font-weight: bold;
      }

      .pay-label {
        text-align: left;
        margin-top: .24rem;
        font-weight: bold;
        font-size: 0.28rem;
      }

      .pay-package {
        padding: .24rem 0;

        .el-checkbox-group {
          display: flex;
          flex-direction: column;
          color: #333333;
          margin-bottom: .24rem;


          .is-checked {
            border-color: #6681FA;

          }

          >label {
            width: 100%;
            margin: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row-reverse;
            height: 0.84rem;
            border-radius: 0.12rem;
            border: 0.02rem solid #D3D5DE;
            padding: 0 0.24rem;
            margin-bottom: .24rem;

            &:last-child {
              margin-bottom: 0;
            }


          }
        }
      }

      .pay-tip {
        font-size: 0.26rem;
        line-height: 0.36rem;
      }
    }
  }

  .footer {
    position: relative;
    background-color: #fff;
    padding: .32rem .24rem;
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    grid-template-rows: 1fr 1fr;
    grid-template-areas: "price last submit" "score last submit";
    grid-column-gap: .08rem;
    font-size: .22rem;

    .price {
      grid-area: price;

      p {
        font-weight: 500;
        color: #333333;
        line-height: 0.34rem;
        text-align: left;
        font-style: normal;
      }
    }

    .score {
      grid-area: score;
      font-weight: 400;
      color: #333333;
      line-height: 0.34rem;
      text-align: left;
      font-style: normal;
    }

    .submit {
      width: 1.7rem;
      height: 0.82rem;
      grid-area: submit;
      background: #6882FB;
      border-radius: 0.41rem;
      font-weight: 400;
      font-size: 0.28rem;
      color: #FFFFFF;
      line-height: 0.82rem;
      text-align: center;
      font-style: normal;
    }

    .last-price {
      grid-area: last;
      font-weight: 400;
      font-size: 0.22rem;
      color: #333333;
      line-height: 0.38rem;
      text-align: left;
      font-style: normal;
      white-space: nowrap;
      display: flex;
      align-items: center;

      span {
        font-weight: 600;
        font-size: 0.28rem;
        color: #FF844E;
        line-height: 0.38rem;
        text-align: left;
        font-style: normal;
      }
    }


  }


}

.pay-tips {
  position: relative;
  width: 90vw;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 0.12rem rgba(0, 0, 0, 0.1);
  padding: .24rem;
  background-image: linear-gradient(to bottom, #A4C8FF, #fff 30%);
  border-radius: .2rem;
  overflow: hidden;


  &-title {
    margin: 0.2rem 0;
    font-weight: 600;
    font-size: 0.32rem;
    color: #222222;
    line-height: 0.48rem;
    text-align: center;
    font-style: normal;
  }

  &-content {
    font-weight: 400;
    font-size: 0.28rem;
    color: #222222;
    line-height: 0.4rem;
    text-align: left;
    font-style: normal;

    p {
      margin-bottom: .24rem;

      span {
        font-weight: bold;
        color: #DB0007;
      }
    }
  }

  &-footer {
    margin: .24rem;
    display: flex;
    align-items: center;
    justify-content: center;
    display: flex;
    align-items: center;
    justify-content: space-between;

    >div {
      flex: 1;
      height: 0.68rem;
      border-radius: 0.42rem;
      font-weight: 500;
      font-size: 0.32rem;
      line-height: 0.4rem;
      text-align: center;
      font-style: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: .24rem;

      &:last-child {
        margin-right: 0;
      }
    }

    &-primary {
      background: linear-gradient(180deg, #768FFF 0%, #6681FA 100%);
      color: #FFFFFF;

    }

    &-text {
      background-color: transparent;
      font-weight: bold;
      color: #333333;
      border: .04rem solid #333
    }
  }

}

.van-popup {
  background-color: transparent !important;
}


.dialog-confirm-content {
  position: relative;
  width: 90vw;
  background-color: #fff;
  border-radius: .24rem;

  >div {
    position: relative;
    width: 100%;
  }

  .dialog-confirm-close {
    position: absolute;
    width: .54rem;
    height: .54rem;
    right: 0;
    top: -1rem;
  }

  .dialog-confirm-header {
    border-top-left-radius: .24rem;
    border-top-right-radius: .24rem;
    overflow: hidden;
    height: 1.24rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(../../assets/images/myLink/result/dialog-header-bg.png);
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    line-height: 0.44rem;
    text-align: left;
    font-style: normal;
    display: flex;
    align-items: center;
    padding: 0 0.4rem;
  }

  .dialog-confirm-body {
    padding: .32rem;
    text-align: center;

    p {
      margin-bottom: .24rem;

      span {
        font-weight: bold;
        color: #DB0007;
      }
    }
  }

  .dialog-confirm-footer {
    background-color: #6882FB16;
    padding: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    >div {
      flex: 1;
      height: 0.68rem;
      border-radius: 0.42rem;
      font-weight: 500;
      font-size: 0.32rem;
      line-height: 0.4rem;
      text-align: center;
      font-style: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: .24rem;

      &:last-child {
        margin-right: 0;
      }
    }

    &-primary {
      background: linear-gradient(180deg, #768FFF 0%, #6681FA 100%);
      color: #FFFFFF;

    }

    &-text {
      background-color: transparent;
      font-weight: bold;
      color: #333333;
      border: .04rem solid #333
    }
  }
}
</style>